export const sentryHandoffErrorIgnoreList = [
  'Zendesk Messaging Widget not found',
  'Freshchat Widget not found',
  'Salesforce Chat Button not found',
  'Salesforce Widget not found',
  'Zendesk Widget not found',
  'Kustomer Widget not found',
  'Failed to create Kustomer conversation',
  'SnapEngage Widget not found',
  'All departments are offline',
  'Department is offline',
];
